import { extend, localize } from 'vee-validate'
import {
  required as rule_required,
  email as rule_email,
  min as rule_min,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,
  max_value as rule_max_value,
  min_value as rule_min_value,
  max as rule_max
} from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'

// eslint-disable-next-line object-curly-newline
import { validatorPositive, validatorUrlValidator, validatorPassword, validatorCreditCard, validatorAtLeastOneUppercase, validatorAtLeastOneDigit, validatorPhoneNumber, validatorIdDDV } from './validators'

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

export const required = extend('required', rule_required)

export const email = extend('email', rule_email)

export const min = extend('min', rule_min)

export const confirmed = extend('confirmed', rule_confirmed)

export const regex = extend('regex', rule_regex)

export const between = extend('between', rule_between)

export const alpha = extend('alpha', rule_alpha)

export const integer = extend('integer', rule_integer)

export const digits = extend('digits', rule_digits)

export const alphaDash = extend('alpha-dash', rule_alpha_dash)

export const alphaNum = extend('alpha-num', rule_alpha_num)

export const length = extend('length', rule_length)

export const maxValue = extend('max_value', rule_max_value)

export const minValue = extend('min_value', rule_min_value)

export const max = extend('max', rule_max)

export const positive = extend('positive', {
  validate: validatorPositive,
  message: 'Please enter positive number!'
})

export const credit = extend('credit-card', {
  validate: validatorCreditCard,
  message: 'It is not valid credit card!'
})

export const password = extend('password', {
  validate: validatorPassword,
  message: 'Your {_field_} must contain at least one uppercase, one lowercase, one special character and one digit'
})

export const url = extend('url', {
  validate: validatorUrlValidator,
  message: 'URL is invalid'
})

export const atLeastOneDigit = extend('at_least_one_digit', validatorAtLeastOneDigit)
export const atLeastOneUppercase = extend('at_least_one_uppercase', validatorAtLeastOneUppercase)


export const PhoneNumber = extend('phone_number', {
  validate: validatorPhoneNumber,
  message: 'Telefonska številka ni veljavna'
})

export const idDDV = extend('id_ddv', {
  validate: validatorIdDDV,
  message: 'ID za DDV ni veljaven, mora biti dolg 8 znakov'
})

// Install English and Arabic localizations.
localize({
  en: {
    messages: en.messages,
    names: {
      email: 'Email',
      password: 'Password'
    },
    fields: {
      password: {
        min: '{_field_} is too short, you want to get hacked?'
      }
    }
  },
  sl: {
    messages: {
      'alpha': 'Polje {_field_} lahko vsebuje le črkovne znake',
      'alpha_dash': 'Polje {_field_} lahko vsebuje le alfanumerične znake kot tudi vezaje in podčrtaje',
      'alpha_num': 'Polje {_field_} lahko vsebuje le alfanumerične znake',
      'alpha_spaces': 'Polje {_field_} lahko vsebuje le črkovne znake in presledke',
      'between': 'Polje {_field_} mora biti med {min} in {max}',
      'confirmed': 'Polje {_field_} se ne ujema',
      'digits': 'Vrednost polja {_field_} mora biti numerična in vsebovati natančno {length} številk',
      'dimensions': 'Slika {_field_} mora biti široka {width} slikovnih točk in visoka {height} slikovnih točk',
      'email': 'Vrednost polja {_field_} mora biti ustrezen e-naslov',
      'excluded': 'Polje {_field_} mora biti ustrezne vrednosti',
      'ext': 'Datoteka polja {_field_} mora biti ustrezna',
      'image': 'Datoteka polja {_field_} mora biti slika',
      'oneOf': 'Polje {_field_} mora biti ustrezne vrednosti',
      'max': 'Dolžina polja {_field_} ne sme biti večja od {length} znakov',
      'max_value': 'Vrednost polja {_field_} mora biti {max} ali manj',
      'mimes': 'Datoteka polja {_field_} mora biti ustreznega tipa',
      'min': 'Dolžina polja {_field_} mora biti vsaj {length} znakov',
      'min_value': 'Vrednost polja {_field_} mora biti {min} ali več',
      'numeric': 'Polje {_field_} lahko vsebuje le numerične znake',
      'regex': 'Vrednost polja {_field_} ni v ustreznem formatu',
      'required': 'Polje {_field_} je obvezno',
      'required_if': 'Polje {_field_} je obvezno',
      'size': 'Velikost datoteke {_field_} mora biti manjša kot {size}KB',
      'double': 'Polje {_field_} mora biti veljavno decimalno mesto'
    }
  }
})
// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////

// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }

// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }

// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }

// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation

//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/

//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }

// export const date = val => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }

// export const max = (val, max) => {

//   // If blank return
//   if (val === undefined || val === null) return true

//   return val.length <= max || `More than ${max} characters are not allowed`
// }

// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }

// export const min = (val, min) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   return val.length >= min || `Minimum ${min} characters are required`
// }

// export const num_range = (val, min, max) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }
